export default __webpack_public_path__ + "static/bonus-e01a7fb70617536212174555ddf97686.png";